/**
 * Was als Profilbild angenommen wird — eine Stelle für alle vier Rollen.
 *
 * Vorher hatte jede Ansicht ihre eigene Antwort: Die Unterstützer:innen prüften
 * Typ und Größe im Browser, Schüler:innen und Lehrkräfte nur die Größe, und die
 * erlaubten Formate standen zweimal im Quelltext. Wer eine PDF-Datei wählte,
 * bekam an der einen Stelle einen Hinweis und an der anderen einen Serverfehler.
 *
 * Der Server prüft dieselben Punkte noch einmal. Hier geht es nur darum, dass
 * niemand erst nach dem Hochladen einer großen Datei erfährt, dass sie zu groß
 * war.
 */
export const AVATAR_TYPES = ['image/jpeg', 'image/png', 'image/gif']

/** Fünf Megabyte — dieselbe Zahl, die `avatarHint` den Leuten nennt. */
export const AVATAR_MAX_BYTES = 5 * 1024 * 1024

/**
 * Prüft eine gewählte Datei.
 *
 * Herausgegeben wird der **Übersetzungsschlüssel**, nicht der fertige Satz: Die
 * Prüfung soll ohne aufgesetzte Sprachumgebung laufen — sonst hängt eine reine
 * Rechenfunktion an i18next, und im Test kommt `undefined` heraus statt einer
 * Meldung. Übersetzt wird dort, wo ohnehin `t` zur Hand ist.
 *
 * @returns {string|null} Schlüssel für die Meldung, oder null wenn alles passt
 */
export const pruefeAvatarDatei = file => {
	if (!file) return null
	if (!AVATAR_TYPES.includes(file.type)) return 'avatarWrongType'
	if (file.size > AVATAR_MAX_BYTES) return 'avatarTooLarge'

	return null
}
